import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: white;
`



// WEBPACK FOOTER //
// ./src/components/Main.js